import { useEffect, useRef, useState } from "react";
import MainLayout from "./../../Layout/MainLayout";
import CustomCard from "../../Components/CustomCard";

import BASEURL from "./../../Config/global";

import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import { useDispatch, useSelector } from "react-redux";
import { activeUser, userLogout } from "../../Store/Slices/APIs";
import { GetAPI } from "../../Api/ApiConfig";
import { crossIcon } from "../../Assets/svg";
import { decryptId } from "../../Services/Common";

import "./style.css";

import { setClearAndStopMixerTrayTrack } from "../../Store/Slices/MyMixerSlice";
import { Modal } from "react-bootstrap";
import Common from "../../Util/common";
import { hideUrlForAge } from "../../Util/global_functions";
import { addMultipleTracks, addPlaylistTracks, playAllTracks, resetConfig, setConfig, setPlayingConfig, setSelectedItem } from "../../Store/Slices/PlayerSlice";
import { handleMixTrayGlobal } from "../../Store/Slices/SaveMixSlice";
import { flattenSoundMixtureTracks, InitPlaylistTrackingIds } from "../../Util/helpers";
import { useTranslation } from "react-i18next";
import { translateTracksBasedOnLanguage } from '../../Util/translator';

const Home = () => {

  let { id } = useParams();
  const originalPath = localStorage.getItem("originalPath") || null;
  const userPrompts = useSelector((state) => state.user.userPrompts);
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const searchField = useRef('null')

  const [searchQuery, setSearchQuery] = useState('');
  const [soundData, setSoundData] = useState([]);
  const [meditationData, setMeditationData] = useState([]);
  const [storiesData, setStoriesData] = useState([]);
  const [articlesData, setArticleData] = useState([]);
  const [featuredMix, setFeaturedMix] = useState([]);
  const [_isSharedMixDeleted, setSharedMixDeleted] = useState(false);
  const [errorMessageForMixture, setErrorMessageForMixture] = useState(false);
  const [greetingMessage, setGreetingMessage] = useState("Welcome");

  useEffect(() => {
    dispatch(userLogout());
    getHomePageData();
    dispatch(setClearAndStopMixerTrayTrack(false));
  }, []);

  useEffect(() => {
    var myDate = new Date();
    var hrs = myDate.getHours();
    if (hrs > 5 && hrs < 12)
      setGreetingMessage(t("home.goodMorning"));
    else if (hrs >= 12 && hrs < 17)
      setGreetingMessage(t("home.goodAfternoon"));
    else if (hrs >= 17 && hrs <= 20)
      setGreetingMessage(t("home.goodEvening"));
    else if (hrs > 20 && hrs <= 24 || hrs < 5)
      setGreetingMessage(t("home.goodNight"));
  }, [t]);

  useEffect(() => {
    if (id) {
      const decryptedId = decryptId(id);
      if (decryptedId) {
        if (originalPath?.split('/')?.[1] == "share.playlist" || originalPath?.split('/')?.[1] == "share.playlist.default") {
          getDataByPlaylistApi(decryptedId);
        } else {
          getDataByApi(decryptedId);
        }
      }
    }
  }, [id, userPrompts?.emptymix_age_restriction_notification]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getHomePageData(searchQuery);
    }, 500);

    // Cleanup timeout when the component unmounts or when searchQuery changes
    return () => clearTimeout(timeoutId);

  }, [searchQuery]);

  const getDataByApi = async (mix_id) => {
    try {
      const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
      if (mix_id === "") {
        ////if user enters wrong id like home/article
        navigate("/404")
        return
      }
      const response = await axios.get(`${BASEURL}/api/sounds/sounds_mixture/${mix_id}`);
      const data = response.data.data[0]
      if (response.data.error && response.data.message) {
        setSharedMixDeleted(true);
        setErrorMessageForMixture(response.data.message || "There is nothing to play for this mix.")
        return
      }
      if (response.data.data.length > 0) {
        const shareItem = response.data.data[0];
        let soundsList = shareItem?.sounds_list || [];

        if (soundsList.length > 0) {
          const tracksForTranslation = soundsList.map(item => ({
            title: item.sounds_detail?.[0]?.title || item.name || "",
            name: item.name || "",
            language: item.sounds_detail?.[0]?.language,
            originalItem: item // Keep reference to original item
          }));

          const translatedTracks = await translateTracksBasedOnLanguage(
            tracksForTranslation,
            i18n?.language,
            {
              getTitle: (d) => d?.title || d?.name || "",
              getLanguage: (d) => d?.language,
            }
          );

          translatedTracks.forEach((translatedTrack, idx) => {
            const originalItem = soundsList[idx];
            if (originalItem) {
              const translatedTitle = translatedTrack.title || translatedTrack.name;
              if (translatedTitle && translatedTitle !== tracksForTranslation[idx]?.title) {
                if (originalItem.sounds_detail && originalItem.sounds_detail[0]) {
                  originalItem.sounds_detail[0].title = translatedTitle;
                }
                if (originalItem.name) {
                  originalItem.name = translatedTitle;
                }
              }
            }
          });
        }

        // when user object has promo_id which means that is the promo user
        // And if code is run for filtering the promo category
        if (user?.promo_id) {
          const catApiUrl = '/api/user/coupon_cat_sub_cat?promo_id=';
          const cat_res = await GetAPI(catApiUrl + user?.promo_id);
          const cats_and_subcats = cat_res?.data?.data;
          if (cats_and_subcats && cats_and_subcats?.['cats_and_subcats'] && !cats_and_subcats['is_new']) {
            const cat_sub_cat_res_obj = cat_res['data']['data']['cats_and_subcats'];
            const shareMixData = response.data.data;
            // filtered the featured mix data according to the selected category
            const [getFeaturedShareMixData] = getFeaturedMixesFilteredMedia(cat_sub_cat_res_obj, shareMixData);
            if (getFeaturedShareMixData) {
              dispatchShareMix(getFeaturedShareMixData)
            } else {
              setErrorMessageForMixture(userPrompts?.no_track_available || "No track available.")
              setSharedMixDeleted(true);
            }
          } else {
            dispatchShareMix(data)
          }
        } else {
          dispatchShareMix(data)
        }
      }
    } catch (error) {
      setErrorMessageForMixture(userPrompts?.mix_deleted_by_sender || "This Mix has been deleted by the sender.")
      setSharedMixDeleted(true);
      console.log(error)
    }
  }

  const getDataByPlaylistApi = async (playlist_id) => {
    try {
      const url = originalPath?.split('/')?.[1] === "share.playlist.default" ? `/api/user/playlists?subId=${playlist_id}` : `/api/user/playlists/${playlist_id}/`;
      const response = await axios.get(BASEURL + url);
      const result = response.data.data;
      if (result?.tracks?.length > 0) {
        const data = result.tracks;
        const obj = {
          id: result?.id,
          type: 'playlist',
          name: result?.name,
          data: data,
          playingId: data[0]?.id,
          restartId: null,
          isRepeat: false,
          isShuffle: false,
          isPlaylist: false,
          isPlaylistMix: false,
          playlist_type: result?.playlist_type
        }
        dispatch(setConfig(obj));
        InitPlaylistTrackingIds(data[0]?.id);
        dispatch(addPlaylistTracks({ data }));
        dispatch(setSelectedItem(data));
        // dispatch(playAllTracks(true));
        dispatch(handleMixTrayGlobal(true));
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getHomePageData = async (query = null) => {
    try {
      let apiUrl = '/api/articles/all-data/', catApiUrl = '/api/user/coupon_cat_sub_cat?promo_id=', cat_res;
      if (query) {
        apiUrl += `?search=${query}`
      }
      const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
      const res = await GetAPI(apiUrl);
      if (user?.promo_id) {
        cat_res = await GetAPI(catApiUrl + user?.promo_id)
      }
      // console.log(cat_res)
      if (!res?.data?.error) {
        // For promo users only!
        const cats_and_subcats = cat_res?.data?.data;
        if (cats_and_subcats && cats_and_subcats?.['cats_and_subcats'] && !cats_and_subcats['is_new'] && user?.promo_id) {

          // Featured Mixes Categories
          const cat_sub_cat_res_obj = cat_res['data']['data']['cats_and_subcats'];
          const featured_mixes_cat = cat_res['data']['data']['cats_and_subcats']['featured_mixes'];
          const featured_mixes_cat_set = new Set(
            featured_mixes_cat?.flatMap(({ category, subcategories }) =>
              [category, ...subcategories].filter(Boolean) // Remove null/undefined values
            ) || []
          );
          // console.log("featured_mixes_cat_set", featured_mixes_cat_set)
          const filteredSoundsMixture = res?.data?.data?.SoundsMixture?.filter(
            item => featured_mixes_cat_set.has(item.featured_category) &&
              (!item.sub_category || featured_mixes_cat_set.has(item.sub_category))
          ) ?? [];
          // filtered the featured mix data according to the selected category
          const getFeaturedMixesFilteredMediaData = getFeaturedMixesFilteredMedia(cat_sub_cat_res_obj, filteredSoundsMixture);
          setFeaturedMix(getFeaturedMixesFilteredMediaData || []);

          // Articles Categories
          const article_cat = cat_res['data']['data']['cats_and_subcats']['article'];
          const article_cat_set = new Set(
            article_cat?.flatMap(({ category, subcategories }) =>
              [category, ...subcategories].filter(Boolean) // Remove null/undefined values
            ) || []
          );
          const filteredArticles = res?.data?.data?.Articles?.filter(
            item => article_cat_set.has(item.articlecategory) &&
              (!item?.subcategory_obj?.child_subcategory_id || article_cat_set.has(item?.subcategory_obj?.child_subcategory_id))
          ) ?? [];
          setArticleData(filteredArticles || []);

          // Sounds Categories
          const sound_cat = cat_res['data']['data']['cats_and_subcats']['sound'];
          const sound_cat_set = new Set(
            sound_cat?.flatMap(({ category, subcategories }) =>
              [category, ...subcategories].filter(Boolean) // Remove null/undefined values
            ) || []
          );
          const filteredSounds = res?.data?.data?.Sounds?.filter(
            item => sound_cat_set.has(item.soundcategory) &&
              (!item?.subcategory_obj?.child_subcategory_id || sound_cat_set.has(item?.subcategory_obj?.child_subcategory_id))
          ) ?? [];
          setSoundData(filteredSounds || []);

          // Meditation Categories
          const meditation_cat = cat_res['data']['data']['cats_and_subcats']['meditation'];
          const meditation_cat_set = new Set(
            meditation_cat?.flatMap(({ category, subcategories }) =>
              [category, ...subcategories].filter(Boolean) // Remove null/undefined values
            ) || []
          );
          const filteredMediations = res?.data?.data?.Mediations?.filter(
            item => meditation_cat_set.has(item.meditationcategory) &&
              (!item?.subcategory_obj?.child_subcategory_id || meditation_cat_set.has(item?.subcategory_obj?.child_subcategory_id))
          ) ?? [];
          setMeditationData(filteredMediations || []);

          // Stories Categories
          const stories_cat = cat_res['data']['data']['cats_and_subcats']['stories'];
          const stories_cat_set = new Set(
            stories_cat?.flatMap(({ category, subcategories }) =>
              [category, ...subcategories].filter(Boolean) // Remove null/undefined values
            ) || []
          );
          const filteredStories = res?.data?.data?.Stories?.filter(
            item => stories_cat_set.has(item.storiescategory) &&
              (!item?.subcategory_obj?.child_subcategory_id || stories_cat_set.has(item?.subcategory_obj?.child_subcategory_id))
          ) ?? [];
          setStoriesData(filteredStories || []);
        } else {
          const { Articles, Mediations, Sounds, Stories, SoundsMixture } = res.data.data;
          setArticleData(Articles || []);
          setMeditationData(Mediations || []);
          setSoundData(Sounds || []);
          setStoriesData(Stories || []);
          // if (user?.status === 'primary') {

          // }
          setFeaturedMix(SoundsMixture || []);
        }

      } else {
        console.log("something is wrong", res.data.message)
      }
    } catch (error) {
      console.log("something is wrong", error)
    }


    // if (!response?.data?.error) {
    // } else {

    // }
    // if (user?.coupon && user?.coupon?.id) {
    //   const cat_url = `/api/user/coupon_cat_sub_cat?promo_id=${user?.coupon?.id}`
    //   const cat_res = await GetAPI(cat_url);


    //   if (response?.data?.data) {
    //     if (cat_res['data']['data']['cats_and_subcats']) {
    //       // const article_cat = cat_res['data']['data']['cats_and_subcats']['article'];
    //       // const sound_cat = cat_res['data']['data']['cats_and_subcats']['sound'];
    //       // const meditation_cat = cat_res['data']['data']['cats_and_subcats']['meditation'];
    //       // const stories_cat = cat_res['data']['data']['cats_and_subcats']['stories'];

    //       // const article_cat_set = new Set(article_cat.flatMap(item => [item.category, item.subcategories]).filter(Boolean) || []);
    //       // const sound_cat_set = new Set(sound_cat.flatMap(item => [item.category, item.subcategories]).filter(Boolean) || []);
    //       // const meditation_cat_set = new Set(meditation_cat.flatMap(item => [item.category, item.subcategories]).filter(Boolean) || []);
    //       // const stories_cat_set = new Set(stories_cat.flatMap(item => [item.category, item.subcategories]).filter(Boolean) || []);

    //       // const filteredArticles = response?.data?.data['Articles'].filter(item => article_cat_set.has(item.articlecategory || item?.subcategory_obj?.child_subcategory_id));
    //       // const filteredSounds = response?.data?.data['Sounds'].filter(item => sound_cat_set.has(item.soundcategory || item?.subcategory_obj?.child_subcategory_id));
    //       // const filteredMediations = response?.data?.data['Mediations'].filter(item => meditation_cat_set.has(item.meditationcategory || item?.subcategory_obj?.child_subcategory_id));
    //       // const filteredStories = response?.data?.data['Stories'].filter(item => stories_cat_set.has(item.storiescategory || item?.subcategory_obj?.child_subcategory_id));

    //       // console.log(filteredSounds)
    //       // setSoundData(filteredSounds || []);
    //       // setMeditationData(filteredMediations || []);
    //       // setStoriesData(filteredStories || []);
    //     } else {
    //       const { Articles, Mediations, Sounds, Stories, SoundsMixture } = response.data.data;
    //       setArticleData(Articles || []);
    //       setMeditationData(Mediations);
    //       setSoundData(Sounds);
    //       setStoriesData(Stories);
    //       setFeaturedMix(SoundsMixture);
    //     }
    //   }

    // } else {
    //   const res = await GetAPI(apiUrl);
    //   const { error } = res.data;
    //   if (error) {
    //     console.log("something is wrong", res.data.message)
    //     return
    //   }
    //   if (res.data && res.data.data) {
    //     const { Articles, Mediations, Sounds, Stories, SoundsMixture } = res.data.data
    //     setArticleData(Articles || []);
    //     setMeditationData(Mediations);
    //     setSoundData(Sounds);
    //     setStoriesData(Stories);
    //     setFeaturedMix(SoundsMixture);
    //   }

    // }
  }

  const getFeaturedMixesFilteredMedia = (cat_sub_cat_res_obj, filteredSoundsMixture) => {

    const validKeys = ['soundcategory', 'articlecategory', 'storiescategory', 'meditationcategory'];

    const keyToCategoryMap = {
      soundcategory: 'sound',
      articlecategory: 'article',
      storiescategory: 'stories',
      meditationcategory: 'meditation',
    };

    const filteredMixture = filteredSoundsMixture.map(group => {
      const filteredSoundList = group.sounds_list.filter(item => {
        const detail = item.sounds_detail[0];

        let matchedKey, matchedValue;

        for (const key of Object.keys(detail)) {
          if (validKeys.includes(key)) {
            matchedKey = key;
            matchedValue = detail[key];
            break; // stop after finding the first valid key
          }
        }


        if (!matchedKey) return false;

        const categoryKey = keyToCategoryMap[matchedKey];
        const subCatId = detail?.subcategory_obj?.child_subcategory_id; // Assuming subcategory ID is directly in this field


        if (!subCatId) {
          // Only check category
          return cat_sub_cat_res_obj[categoryKey]?.some(el => el.category === matchedValue);
        } else {
          // Check both category and subcategory
          return cat_sub_cat_res_obj[categoryKey]?.some(
            el => el.category === matchedValue && el.subcategories.includes(subCatId)
          );
        }

      });

      if (filteredSoundList.length === 0) return null;

      return { ...group, sounds_list: filteredSoundList };
    }).filter(group => group !== null); // Remove nulls



    return filteredMixture || []

  }

  const dispatchShareMix = (item) => {
    // Active User
    dispatch(activeUser());

    const data = flattenSoundMixtureTracks(item);
    const playingId = data[0]['id'];
    const isPlaylist = item?.isPlaylist;
    const playlist_type = item?.playlist_type;

    const filtered = item?.sounds_list?.filter(s => {
      // for playlist mixes, only consider sounds for auto play logic. for user created mixes, consider all types
      if (playlist_type === "music_lullaby") {
        return s.sounds_detail?.[0]?.type !== 'sounds';
      } else {
        return s.sounds_detail?.[0]?.type === 'sounds' && (s.sounds_detail?.[0]?.soundcategory === 163 || s.sounds_detail?.[0]?.soundcategory === 164);
      }
    });

    const obj = {
      id: item?.id,
      type: isPlaylist ? 'playlist' : 'mix',
      name: item?.title ?? item?.name,
      data: data,
      playingId: isPlaylist ? playingId : null,
      restartId: null,
      isRepeat: item?.repeat ?? false,
      isShuffle: item?.shuffle ?? false,
      isPlaylist: false,
      isPlaylistMix: isPlaylist,
      shouldPlay: filtered[0]?.['sounds_detail']?.[0]?.id || null,
      playlist_type: isPlaylist ? playlist_type : "default",
    }
    dispatch(addMultipleTracks({ item }));
    dispatch(setConfig(obj));
    dispatch(handleMixTrayGlobal(true));
  }

  // const notify = () => {
  //   toast('🦄 Wow so easy!', {
  //     position: "top-right",
  //     autoClose: 5000,
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //     progress: undefined,
  //     theme: "light",
  //     transition: Bounce,
  //     type: "error"
  //   });
  // };

  return (
    <>
      <MainLayout title={greetingMessage}>
        <div className="search-bar mb-4 position-relative">
          <input
            type="search"
            className={`searchBar w-100 pe-5`}
            placeholder={t("home.searchPlaceholder")}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            ref={searchField}
            onFocus={() => searchField.current.placeholder = ""}
            onBlur={() => searchField.current.placeholder = t("home.searchPlaceholder")}
          />
          {
            searchQuery.length > 0 && (
              <button
                className="closeButton notButton position-absolute end-0 top-0 px-3 py-2"
                onClick={() => setSearchQuery('')}
              >
                <img src={crossIcon} alt="" />
              </button>
            )
          }
        </div>
        <div className="row mb-3 home-page-row">
          {
            (searchQuery != '' && featuredMix.length == 0) ? '' : (
              <>
                <div className="col-6">
                  <h2 className="sectionTitle">{t("home.featuredMixes")}</h2>
                </div>
                <div className="col-6 text-end">
                  <Link
                    to={"/featured-mixes"}
                    className="smallText goldenColor2 text-decoration-none d-flex align-items-center justify-content-end ms-auto"
                  >
                    {t("home.browseCollection")}
                    <svg xmlns='http://www.w3.org/2000/svg' width={'15px'} viewBox='0 0 16 16' fill='#f7ba31' style={{ transform: 'rotate(270deg)' }}>
                      <path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z' />
                    </svg>
                  </Link>
                </div>
              </>
            )
          }
          <div className="col-12">
            <div className="homeboxesWrapper">
              {/* <button onClick={notify}>Notify!</button>
              <ToastContainer /> */}
              {
                featuredMix.slice(0, 20).map((item, index) => (
                  // Render your original data items here
                  <CustomCard
                    key={index}
                    title={item.title}
                    image={`${item.banner}`}
                    alt={"In The News"}
                    item={item}
                    type={Common.CATEGORIES['mix']}
                  />
                ))
              }
            </div>
          </div>
        </div>
        <div className="row mb-3 home-page-row">
          {
            (searchQuery != '' && soundData.length == 0) ? '' : (
              <>
                <div className="col-6">
                  <h2 className="sectionTitle">{t("nav.sounds")}</h2>
                </div>
                <div className="col-6 text-end">
                  <Link
                    to={"/sounds"}
                    className="smallText goldenColor2 text-decoration-none d-flex align-items-center justify-content-end ms-auto"
                  >
                    {t("home.browseCollection")}
                    <svg xmlns='http://www.w3.org/2000/svg' width={'15px'} viewBox='0 0 16 16' fill='#f7ba31' style={{ transform: 'rotate(270deg)' }}>
                      <path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z' />
                    </svg>
                  </Link>
                </div>
              </>
            )
          }
          <div className="col-12">
            <div className="homeboxesWrapper">
              {
                soundData.slice(0, 20).map((item, index) => (
                  // Render your original data items here
                  <CustomCard
                    key={index}
                    title={item.title}
                    image={`${item.image}`}
                    alt={"In The News"}
                    item={item}
                    type={Common.CATEGORIES['sounds']}
                  />
                ))
              }
            </div>
          </div>
        </div>
        <div className="row mb-3 home-page-row">
          {
            (searchQuery != '' && meditationData.length == 0) ? '' : (
              <>
                <div className="col-6">
                  <h2 className="sectionTitle">{t("nav.relaxRest")}</h2>
                </div>
                <div className="col-6 text-end">
                  <Link
                    to={"/relax-rest"}
                    className="smallText goldenColor2 text-decoration-none d-flex align-items-center justify-content-end ms-auto"
                  >
                    {t("home.browseCollection")}
                    <svg xmlns='http://www.w3.org/2000/svg' width={'15px'} viewBox='0 0 16 16' fill='#f7ba31' style={{ transform: 'rotate(270deg)' }}>
                      <path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z' />
                    </svg>
                  </Link>
                </div>
              </>
            )
          }
          <div className="col-12">
            <div className="homeboxesWrapper">
              {
                meditationData.slice(0, 20).map((item, index) => (
                  <CustomCard
                    key={index}
                    title={item.title}
                    image={`${item.image}`}
                    alt={"relaxation"}
                    item={item}
                    type={Common.CATEGORIES['audio']}
                  />
                ))
              }

            </div>
          </div>
        </div>
        <div className="row mb-3 home-page-row">
          {
            (searchQuery != '' && storiesData.length == 0) ? '' : (
              <>
                <div className="col-6">
                  <h2 className="sectionTitle">{t("nav.stories")}</h2>
                </div>
                <div className="col-6 text-end">
                  <Link
                    to={"/stories"}
                    className="smallText goldenColor2 text-decoration-none d-flex align-items-center justify-content-end ms-auto"
                  >
                    {t("home.browseCollection")}
                    <svg xmlns='http://www.w3.org/2000/svg' width={'15px'} viewBox='0 0 16 16' fill='#f7ba31' style={{ transform: 'rotate(270deg)' }}>
                      <path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z' />
                    </svg>
                  </Link>
                </div>
              </>
            )
          }
          <div className="col-12">
            <div className="homeboxesWrapper">

              {
                storiesData.slice(0, 20).map((item, index) => (
                  <CustomCard
                    key={index}
                    title={item.title}
                    image={`${item.image}`}
                    alt={"Stories"}
                    item={item}
                    type={Common.CATEGORIES['audio']}
                  />
                )
                )}
            </div>
          </div>
        </div>
        <div className="row mb-3 home-page-row">
          {
            (searchQuery != '' && articlesData.length == 0 || !hideUrlForAge()) ? '' : (
              <>
                <div className="col-6">
                  <h2 className="sectionTitle">{t("nav.avArticles")}</h2>
                </div>
                <div className="col-6 text-end">
                  <Link
                    to={"/articles"}
                    className="smallText goldenColor2 text-decoration-none d-flex align-items-center justify-content-end ms-auto"
                  >
                    {t("home.browseCollection")}
                    <svg xmlns='http://www.w3.org/2000/svg' width={'15px'} viewBox='0 0 16 16' fill='#f7ba31' style={{ transform: 'rotate(270deg)' }}>
                      <path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z' />
                    </svg>
                  </Link>
                </div>
              </>
            )
          }
          <div className="col-12">
            <div className="homeboxesWrapper">
              {

                articlesData.slice(0, 20).map((item, index) => (
                  <CustomCard
                    key={index}
                    title={item.title}
                    image={`${item.image}`}
                    alt={"Articles"}
                    item={item}
                    type={Common.CATEGORIES['audio']}
                  />
                ))
              }

            </div>
          </div>
        </div>
      </MainLayout>

      <Modal
        show={_isSharedMixDeleted}
        centered
        className="invite-success-modal success-modal"
        backdrop="static"
      >
        <Modal.Body>
          <div className="p-5 pt-2 px-4 w-100">
            <div className="text-end pb-3">
              <button className="closeButton notButton ms-auto" onClick={() => { setSharedMixDeleted(false); navigate("/home"); }}>
                <img src={crossIcon} alt="" />
              </button>
            </div>
            <h2 className="font-16 lh-16 my-5 fw-normal text-center">{errorMessageForMixture}</h2>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Home;
